import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"waveWrapper waveAnimation\"><div class=\"waveWrapperInner bgTop\"><div class=\"wave waveTop\" style=\"background-image:url(&#39;/images/wave-top.png&#39;);\"></div></div><div class=\"waveWrapperInner bgMiddle\"><div class=\"wave waveMiddle\" style=\"background-image:url(&#39;/images/wave-mid.png&#39;);\"></div></div><div class=\"waveWrapperInner bgBottom\"><div class=\"wave waveBottom\" style=\"background-image:url(&#39;/images/wave-bot.png&#39;);\"></div></div></div>", 1);

const _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["animheader", {
      second: $props.second
    }])
  }, _hoisted_2, 2);
}